module.exports = __webpack_public_path__ + "img/ercode.0f1030ec.png";